import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faUsers,
  faFileInvoiceDollar,
  faHandHoldingUsd,
  faExclamationTriangle,
  faArrowUp,
  faArrowDown
} from '@fortawesome/free-solid-svg-icons';

const DashKPICards = ({ showCardData }) => {

  const growthPercent = showCardData?.totalMembers?.newLastMonth
    ? ((showCardData?.totalMembers?.newThisMonth - showCardData?.totalMembers?.newLastMonth) /
      showCardData?.totalMembers?.newLastMonth) *
    100
    : 0;

  const currentYTD = Number(showCardData?.totalBilledcurrentYearTillDate || 0);
  const lastYearTotal = Number(showCardData?.totalBilledLastYear || 0);

  const ytdGrowthPercent = lastYearTotal
    ? ((currentYTD - lastYearTotal) / lastYearTotal) * 100
    : 0;

  const thisYearPaid = showCardData?.thisYear?.paid || 0;
  const lastYearPaid = showCardData?.lastYear?.paid || 0;
  const thisYearDue = showCardData?.thisYear?.due || 0;
  const lastYearDue = showCardData?.lastYear?.due || 0;

  const paidGrowth = lastYearPaid ? ((thisYearPaid - lastYearPaid) / lastYearPaid) * 100 : 0;
  const dueGrowth = lastYearDue ? ((thisYearDue - lastYearDue) / lastYearDue) * 100 : 0;


  return (
    <section className=" mx-auto py-2 pr-2 mt-2">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="bg-white rounded-xl shadow-md p-6 border-l-4 border-blue-500">
          <div className="flex justify-between items-start">
            <div>
              <p className="text-gray-500 text-sm font-medium">Active Members</p>
              <h3 className="text-2xl font-bold mt-1">{showCardData?.totalMembers?.newThisMonth ? showCardData?.totalMembers?.newThisMonth : 0}</h3>
            </div>
            <div className="bg-blue-100 p-2 rounded-lg">
              <FontAwesomeIcon icon={faUsers} className="text-blue-600" />
            </div>
          </div>
          <div className="mt-4">
            <p
              className={`text-sm font-medium ${growthPercent >= 0 ? 'text-green-600' : 'text-red-600'
                }`}
            >
              <FontAwesomeIcon
                icon={growthPercent >= 0 ? faArrowUp : faArrowDown}
                size="sm"
                className="mr-1"
              />
              {Math.abs(growthPercent)?.toFixed(1)}% from last month
            </p>
          </div>
        </div>
        <div className="bg-white rounded-xl shadow-md p-6 border-l-4 border-green-500">
          <div className="flex justify-between items-start">
            <div>
              <p className="text-gray-500 text-sm font-medium">Total Billed YTD</p>
              <h3 className="text-2xl font-bold mt-1">
                ${Number(showCardData?.totalBilledcurrentYearTillDate || 0).toLocaleString()}
              </h3>
            </div>
            <div className="bg-green-100 p-2 rounded-lg">
              <FontAwesomeIcon icon={faFileInvoiceDollar} className="text-green-600" />
            </div>
          </div>
          <div className="mt-4">
            <p
              className={`text-sm font-medium ${ytdGrowthPercent >= 0 ? 'text-green-600' : 'text-red-600'
                }`}
            >
              <FontAwesomeIcon
                icon={ytdGrowthPercent >= 0 ? faArrowUp : faArrowDown}
                size="sm"
                className="mr-1"
              />
              {Math.abs(ytdGrowthPercent).toFixed(1)}% from last year
            </p>
          </div>
        </div>
        <div className="bg-white rounded-xl shadow-md p-6 border-l-4 border-purple-500">
          <div className="flex justify-between items-start">
            <div>
              <p className="text-gray-500 text-sm font-medium">Total Paid YTD</p>
              <h3 className="text-2xl font-bold mt-1">
                ${thisYearPaid.toLocaleString()}
              </h3>
            </div>
            <div className="bg-purple-100 p-2 rounded-lg">
              <FontAwesomeIcon
                icon={faHandHoldingUsd}
                className="text-purple-600"
              />
            </div>
          </div>
          <div className="mt-4">
            <p
              className={`text-sm font-medium ${paidGrowth >= 0 ? "text-green-600" : "text-red-600"
                }`}
            >
              <FontAwesomeIcon
                icon={paidGrowth >= 0 ? faArrowUp : faArrowDown}
                size="sm"
                className="mr-1"
              />
              {Math.abs(paidGrowth).toFixed(1)}% from last year
            </p>
          </div>
        </div>

        {/* Total Outstanding Dues */}
        <div className="bg-white rounded-xl shadow-md p-6 border-l-4 border-red-500">
          <div className="flex justify-between items-start">
            <div>
              <p className="text-gray-500 text-sm font-medium">
                Total Outstanding Dues
              </p>
              <h3 className="text-2xl font-bold mt-1">
                ${thisYearDue.toLocaleString()}
              </h3>
            </div>
            <div className="bg-red-100 p-2 rounded-lg">
              <FontAwesomeIcon
                icon={faExclamationTriangle}
                className="text-red-600"
              />
            </div>
          </div>
          <div className="mt-4">
            <p
              className={`text-sm font-medium ${dueGrowth >= 0 ? "text-red-600" : "text-green-600"
                }`}
            >
              <FontAwesomeIcon
                icon={dueGrowth >= 0 ? faArrowUp : faArrowDown}
                size="sm"
                className="mr-1"
              />
              {Math.abs(dueGrowth).toFixed(1)}% from last year
            </p>
          </div>
        </div>
      </div>
    </section>

  )
}

export default DashKPICards
